import { atsApiQuery } from '..';
import { getAssessmentFormData } from './utils';

export const assessmentApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      createAssessment: builder.query({
        transformResponse: (response) => response.data,
        query: ({ payload }) => {
          return { method: 'post', url: `/ats_assessments`, data: payload };
        },
      }),
      getAssessment: builder.query({
        transformResponse: (response) => response.data,
        query: ({ assessmentId }) => {
          return { method: 'get', url: `/ats_assessments/${assessmentId}` };
        },
        keepUnusedDataFor: 0,
      }),
      sendAssessment: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ payload }) => {
          const { assessmentId, params } = payload;
          const fd = new FormData();
          const formData = getAssessmentFormData(fd, params);
          return {
            method: 'put',
            url: `/ats_assessments/${assessmentId}/send_assessment`,
            data: formData,
          };
        },
      }),
      sendScheduledAssessmentNow: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ assessmentId }) => {
          return {
            method: 'put',
            url: `/ats_assessments/${assessmentId}/send_assessment`,
          };
        },
      }),
      scheduleAssessment: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ payload }) => {
          const { assessmentId, params } = payload;
          const fd = new FormData();
          const formData = getAssessmentFormData(fd, params);
          return {
            method: 'put',
            url: `/ats_assessments/${assessmentId}/schedule`,
            data: formData,
          };
        },
      }),
      cancelScheduledAssessment: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ payload }) => {
          const { assessmentId } = payload;
          return {
            method: 'put',
            url: `/ats_assessments/${assessmentId}/cancel_schedule`,
          };
        },
      }),
      createAndSendAssessment: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ payload }) => {
          const {
            ats_job_stage_id,
            ats_job_stage_action_id,
            ats_application_id,
            params,
            ...rest
          } = payload;

          const fd = new FormData();

          // Append the adhoc assessment info
          fd.append('ats_job_stage_id', ats_job_stage_id);
          fd.append('ats_job_stage_action_id', ats_job_stage_action_id);
          fd.append('ats_application_id', ats_application_id);

          // Append all other params using the existing form data helper
          getAssessmentFormData(fd, params);

          // Handle any additional fields from rest
          Object.entries(rest).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
              fd.append(key, value);
            }
          });

          return {
            method: 'post',
            url: `/ats_assessments/send_adhoc_assessments`,
            data: fd,
          };
        },
      }),
      updateAssessment: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ payload }) => {
          const { assessmentId, params } = payload;
          const fd = new FormData();
          const formData = getAssessmentFormData(fd, params);
          return {
            method: 'put',
            url: `/ats_assessments/${assessmentId}`,
            data: formData,
          };
        },
      }),
      cancelAssessment: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ assessmentId }) => {
          return { method: 'delete', url: `/ats_assessments/${assessmentId}` };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useCreateAssessmentQuery,
  useGetAssessmentQuery,
  useSendAssessmentMutation,
  useScheduleAssessmentMutation,
  useCreateAndSendAssessmentMutation,
  useUpdateAssessmentMutation,
  useCancelAssessmentMutation,
  useCancelScheduledAssessmentMutation,
  useSendScheduledAssessmentNowMutation,
} = assessmentApi;
